import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useFloatingSelect } from '../../../hooks'
import {
  FloatingSelectDropdown,
  FloatingTooltip,
  FloatingTrigger,
} from '../../Floating'

import { BREADCRUMBS_COLLAPSED_BUTTON_STRING_CONTENT } from './BreadcrumbsCollapsed.constants'
import { ListItem } from './ListItem'

import * as styles from './BreadcrumbsCollapsed.module.css'

function BreadcrumbsCollapsed({ items }) {
  const { t } = useTranslation()

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({ placement: FLOATING_ELEMENT_PLACEMENT.bottom })

  function handleClick() {
    setOpen(open => !open)
  }

  function handleClickItem({ onClick }, event) {
    setOpen(false)

    onClick?.(event)
  }

  return (
    <FloatingTrigger context={context}>
      <div>
        <FloatingTooltip
          content={t(
            isOpen ? 'Select.CloseTooltipKey' : 'Select.OpenTooltipKey'
          )}
        >
          <span className={styles.BreadcrumbsCollapsed} onClick={handleClick}>
            {BREADCRUMBS_COLLAPSED_BUTTON_STRING_CONTENT}
          </span>
        </FloatingTooltip>

        <FloatingSelectDropdown
          context={context}
          floatingStyles={floatingStyles}
          getFloatingProps={getFloatingProps}
          isOpen={isOpen}
          refs={refs}
        >
          <div className={styles.list}>
            {items.map(item => (
              <ListItem
                item={item}
                key={item.id}
                onClickItem={handleClickItem}
              />
            ))}
          </div>
        </FloatingSelectDropdown>
      </div>
    </FloatingTrigger>
  )
}

export default BreadcrumbsCollapsed
